import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
    routes: [{
            path: '/',
            redirect: '/login'
        },
        //登录
        {
            path: '/login',
            component: () => import('./views/Login.vue')
        },
        //首页
        {
            path: '/home',
            component: () => import('./views/Home.vue'),
            redirect: to => {
				return '/home/parameter'
			},
            children: [{
                path: '/home/parameter',
                name:'parameter',
                component: () => import('./views/Parameter.vue')
            },
            {
                path: '/home/case',
                name:'case',
                component: () => import('./views/Case.vue')
            },
            {
                path: '/home/caseDetails',
                name:'case',
                component: () => import('./views/caseDetails.vue')
            },
            {
                path: '/home/team',
                name:'team',
                component: () => import('./views/Team.vue')
            },
            {
                path: '/home/teamDetails',
                name:'team',
                component: () => import('./views/teamDetails.vue')
            },
            {
                name:'upload',

                path: '/home/upload',
                component: () => import('./views/Upload.vue')
            },
            {
                name:'Administrator',

                path: '/home/Administrator',
                component: () => import('./views/Administrator.vue')
            }]
        }

    ]
})